export default __webpack_public_path__ + "locales/pl/DataReassignmentDialog.json?hash=433bbc7719ca53040d076a239b665888";